const HEADER_TRACK_ORDER_CONSTANTS = {
  ORDERS_NOW: 'ordersNow',
  TRACK_ORDER: 'trackOrder',
  WE_ARE_WORKING_ON: 'weAreWorkingOn',
  YOUR_ORDER: 'yourOrder',
  HAS_BEEN_CONFIRMED: 'hasBeenConfirmed',
  HAS_SCHEDULED: 'hasScheduled',
  PICKUP: 'takeaway',
  AT: 'At',
  DELIVERY: 'delivery',
};
export const MAX_RETRY_INTERVAL = 180000; // 3 mins

export default HEADER_TRACK_ORDER_CONSTANTS;
